import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { ComboNutritionInformation } from 'features/menu/components/product-detail/product-nutrition-information/combo-nutrition-information';
import { ItemNutritionInformation } from 'features/menu/components/product-detail/product-nutrition-information/item-nutrition-information';
import { useProductWizardContext } from 'features/menu/components/product-wizard';

import Modal, { ModalContent, ModalSize } from 'components/modal';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';
import { t } from 'state/intl/translations';
import { isItem } from 'state/unified-menu/utils';
import { getDesignToken, primitive } from 'styles/constants';

interface INutritionModalProps {
  onDismiss: () => void;
}

/**
 *
 * TODO: I see that we have two nutrition modals.
 * We should either unify them or differentiate their names to clarify their purpose.
 * the other modal is in:  src/components/nutrition/index.tsx
 */
export const NutritionModal: React.FC<INutritionModalProps> = ({ onDismiss }) => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { calorie } = featureDisclaimers || {};
  const { selectedProduct } = useProductWizardContext();

  return (
    <Modal
      size={ModalSize.FULLSCREEN}
      onDismiss={onDismiss}
      amplitudeEventData={{
        modalAppearanceEventMessage: 'Nutritional Information',
      }}
      testID="nutrition-modal"
      backgroundColor={getDesignToken('background-default')}
      header={t('nutritionalInformationAndAllergen')}
      headerTextIsBelowCloseButton
    >
      <ModalContent alignItems="center">
        <ScrollView showsVerticalScrollIndicator={false} focusable>
          {isItem(selectedProduct) ? (
            <ItemNutritionInformation item={selectedProduct} />
          ) : (
            <ComboNutritionInformation />
          )}
          <SanityBlockRenderer
            testID="nutrition-disclaimer"
            content={calorie?.localeRaw}
            textProps={{
              variant: 'copyTwo',
              textAlign: 'left',
              fontSize: 'xs',
              marginBottom: '$4',
            }}
            linkProps={{
              variant: 'copyTwo',
              fontSize: 'xs',
              textDecorationLine: 'underline',
              color: `${primitive.$bbqBrown}`,
            }}
            focusable
          />
        </ScrollView>
      </ModalContent>
    </Modal>
  );
};
